// extracted by mini-css-extract-plugin
export var animationContainer = "_j4-0";
export var footer = "_j4-1";
export var gray = "_j4-2";
export var lineItem = "_j4-3";
export var lineItemImage = "_j4-4";
export var lineItemInfo = "_j4-5";
export var lineItemText = "_j4-6";
export var lineItems = "_j4-7";
export var modalContent = "_j4-8";
export var options = "_j4-9";
export var orderName = "_j4-a";
export var refundAmount = "_j4-b";